import React, { useState } from 'react'
import { message } from 'antd'
import '../../node_modules/antd/dist/antd.css'

function Login () {
  const [userName, setUserName] = useState('')
  const handleSubmit = (e) => {
    e.preventDefault()
    sessionStorage.setItem('userName', userName)
    sessionStorage.setItem('isLogged', true)
    message.loading('Please Wait', [1], () => {
      message.success('Successfully Logged In')
      window.location.href = '/'
    })
  }

  const handleChange = (e) => {
    setUserName(e.target.value)
  }
  return (
    <div className='container mt-5 mb-5 d-flex flex-column align-items-center '>
      <form className='p-5 loginform' onSubmit={handleSubmit}>
        <h3 className='mb-4' style={{ textAlign: 'center' }}>
          Login
        </h3>
        <div className='form-group'>
          <label for='exampleInputEmail1'>Username</label>
          <input
            type='text'
            className='form-control'
            id='exampleInputEmail1'
            name='userName'
            placeholder='Enter username'
            required
            value={userName}
            onChange={handleChange}
          />
        </div>
        <div className='form-group'>
          <label for='exampleInputPassword1'>Password</label>
          <input type='password' className='form-control' id='exampleInputPassword1' placeholder='Password' required />
        </div>
        <center>
          <button type='submit' className='btn btn-dark'>
            Submit
          </button>
        </center>
      </form>
    </div>
  )
}
export default Login
